import { AxiosResponse } from 'axios';
import { AdAccount } from '../../models/ext/fbads';
import { apiV1 } from '../axios';

export const fetchAdAccounts = async (integId: number) => {
    return apiV1.get<unknown, AxiosResponse<Array<AdAccount>>>(
        `/ext/facebookads/${integId}/adaccounts`
    );
};
